import React, { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import PropTypes from 'prop-types';

am4core.useTheme(am4themes_animated);

class TreemapChart extends Component {
	static propTypes = {
		id: PropTypes.string.isRequired,
		dataset: PropTypes.array.isRequired,
	};

	componentDidUpdate(prevProps) {
		if (prevProps.dataset !== this.props.dataset) {
			this.renderTreemap(this.props.dataset);
		}
	}

	renderTreemap() {
		const { id, dataset } = this.props;
		let chart = am4core.create(id, am4charts.TreeMap);
		chart.hiddenState.properties.opacity = 0;

		chart.data = dataset;

		/* Set color step */
		chart.colors.step = 2;
		chart.paddingTop = 0;  // Remove padding at the top
		chart.layoutAlgorithm = chart.binaryTree;

		/* Define data fields */
		chart.dataFields.name = "key";
		chart.dataFields.value = "value";
		chart.dataFields.children = "value";

		/* Create top-level series */
		var level1 = chart.seriesTemplates.create("0");
		var level1_column = level1.columns.template;
		level1_column.fillOpacity = 0;
		level1_column.strokeOpacity = 0;

		/* Create second-level series */
		var level2 = chart.seriesTemplates.create("1");
		var level2_column = level2.columns.template;
		level2_column.column.cornerRadius(10, 10, 10, 10);
		level2_column.fillOpacity = 0.8;
		level2_column.stroke = am4core.color("#fff");
		level2_column.strokeWidth = 5;
		level2_column.strokeOpacity = 1;

		var level2_bullet = level2.bullets.push(new am4charts.LabelBullet());
		level2_bullet.locationY = 0.5;
		level2_bullet.locationX = 0.5;
		level2_bullet.label.text = "{key}";
		level2_bullet.label.fill = am4core.color("#fff");

		/* Add a navigation bar */
		chart.navigationBar = new am4charts.NavigationBar();

		chart.legend = new am4charts.Legend();
		chart.legend.position = "bottom";
		chart.legend.valign = "center";
		chart.legend.align = "center";
		chart.legend.contentAlign = "center";
		chart.fontSize = 10

		if (dataset) {
			chart.legend.events.on("datavalidated", sortingDataTerbesar);
			function sortingDataTerbesar() {
				const { markers } = chart.legend;

				for (const [idx, dataItem] of chart.data.entries()) {
					for (const marker of markers) {
						if (marker.dataItem.name === dataItem.name) {
							marker.customSortIndex = idx;
						}
					}
				}

				markers.sort((a, b) => a.customSortIndex - b.customSortIndex);
			}
		}
	}

	componentWillUnmount() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	render() {
		const { id } = this.props;
		return <div id={id} style={{ width: "100%", height: "650px" }}></div>;
	}
}

export default TreemapChart;
